module.exports = __webpack_public_path__ + "img/bg5.ad40c256.png";